import React from 'react';
import DietaryNeeds from './DietaryNeeds';
import {useParams} from 'react-router-dom';
import {Container, Box} from '@mui/material';
import {retrieveProfile} from '../../ProfilesSlice';
import {useDispatch, useSelector} from 'react-redux';
import PermissionCheck from '../../Components/PermissionCheck';
import WelfareOptions from './WelfareOptions';
import FreeSchoolMealsFields from './FreeSchoolMealsFields';

const DietaryWelfareEthnicityTab = () => {
    const {studentId} = useParams();
    const dispatch = useDispatch();
    const isPersonApplicant = useSelector(state => state.profilesInfo.selectedProfile.isApplicant);
    const selectedProfile = useSelector(state => state.profilesInfo.selectedProfile);

    return (
        <Container
            xs={12}
            sm={12}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: 0
            }}
        >
            <Box sx={{ mb: { xs: 2, sm: 0 } }}>
            <PermissionCheck
                permissionModule={isPersonApplicant ? 'ApplicantDietaryNeedsAndFoodAllergies' : 'StudentDietaryNeedsAndFoodAllergies'}
                studentProfile={selectedProfile}
                render={(readonly) => <DietaryNeeds
                    readonly={readonly}
                    onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                />}
            />
            </Box>
            <Box sx={{ my: { xs: 2, sm: 0 } }}>
            <PermissionCheck
                permissionModule={isPersonApplicant ? 'ApplicantFreeSchoolMealsEligibility' : 'StudentFreeSchoolMealsEligibility'}
                studentProfile={selectedProfile}
                render={(readonly) => <FreeSchoolMealsFields
                    readonly={readonly}
                    onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                />}
            />
                </Box>
            <Box sx={{ mt: { xs: 2, sm: 0 } }}>
            <PermissionCheck
                permissionModule={isPersonApplicant ? 'ApplicantWelfare' : 'StudentWelfare'}
                studentProfile={selectedProfile}
                render={(readonly) => <WelfareOptions
                    readonly={readonly}
                    onConfirmSuccess={async () => dispatch(retrieveProfile({studentId}))}
                />}
            />
            </Box>
        </Container>
    );
};

export default DietaryWelfareEthnicityTab;
